import {useLogin} from '../../user/useLogin.hook';
import {OnlyInLoginCheckerProps} from './OnlyInLoginCheckerProps';

export function OnlyInLoginChecker({children}: OnlyInLoginCheckerProps) {
  const {isLogin} = useLogin();
  if (!isLogin) {
    return null;
  }
  return <>{children}</>;
}
